import { Box, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import Icon from '@mui/material/Icon';

interface PageHeaderProps {
  title: string;
  icon: FC;
  children?: ReactNode;
  titleAction?: ReactNode;
}

const PageHeader = (props: PageHeaderProps): JSX.Element => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
      <Box display="flex" gap={1} alignItems="center">
        <Icon component={props.icon} sx={{ fontSize: '28px', color: '#222222' }} />
        <Typography color="'#222222'" fontSize="30px" fontWeight={600}>
          {props.title}
        </Typography>
        {props.titleAction}
      </Box>
      {props.children}
    </Box>
  );
};

export default PageHeader;
